import type { Fonts } from 'figlet';

export interface IFont {
  name: string;
  lower?: string[];
  upper?: string[];
  digits?: string[];
  categories: FontCategory[];
  mainCategory: FontCategory;
  className?: string;
  prefix?: string;
  suffix?: string;
  id: number;
  transform?: (input: string) => string;
  asciiFont?: Fonts;
}

export type AllFonts = {
  [key: number]: IFont;
};

export enum FontCategory {
  All,
  Basic,
  Bold,
  Cool,
  Cursive,
  Fancy,
  Glitch,
  Small,
  SymbolText,
  Wrappers,
  Lettercases,
  Codes,
  Recents,
  TextArt,
}
